import { useNavigate } from "react-router-dom";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const MobileCTA = () => {
  const navigate = useNavigate();

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 md:hidden z-50 bg-white/95 backdrop-blur-md border-t border-slate-200 p-3 mobile-cta-bar"
      data-testid="mobile-cta-bar"
    >
      <div className="flex items-center gap-3">
        <a href="tel:626-526-1420" className="flex-1">
          <Button 
            variant="outline"
            className="w-full h-12 border-slate-300 text-slate-700 font-semibold"
            data-testid="mobile-call-btn"
          >
            <Phone className="w-5 h-5 mr-2" />
            Call Now
          </Button>
        </a>
        <Button 
          className="flex-1 h-12 bg-[#D32F2F] hover:bg-[#B71C1C] text-white font-bold"
          onClick={() => navigate('/get-offer')}
          data-testid="mobile-offer-btn"
        >
          Get Cash Offer
        </Button>
      </div>
    </div>
  );
};

export default MobileCTA;
